import './read-more.scss'

( function( $ ) {
    $( document ).ready( function () {
        $( '.js-readMore' ).each( function () {
            const $readMore = $( this );
            const $toggle   = $readMore.find( '.js-readMoreToggle' );
            const $content  = $readMore.find( '.js-readMoreContent' );
            const $label    = $toggle.find( '.m-readMore__toggleLabel' );

            if ( ! $toggle.length || ! $content.length ) {
                return;
            }

            // Progressive enhancement: collapse the extra content and reveal
            // the toggle only once JS is running. Without JS everything shows.
            $content.hide();
            $readMore.addClass( '-jsReady' );

            $toggle.on( 'click', function () {
                const isOpen = $readMore.hasClass( '-open' );

                $content.stop( true, true ).slideToggle( 250 );
                $readMore.toggleClass( '-open' );
                $toggle.attr( 'aria-expanded', ( ! isOpen ).toString() );
                $label.text( isOpen ? $toggle.data( 'more' ) : $toggle.data( 'less' ) );
            } );
        } );
    } );
} ) ( jQuery );
